import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Party } from '../models/user-details-form';
import { environment } from '../../../../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PartyService {
  private http = inject(HttpClient);

  getParties(query: string) {
    return this.http.get<Party[]>(`${environment.apiUrl}/parties`, { params: { query } });
  }

  create(party: Party) {
    return this.http.post<Party>(`${environment.apiUrl}/parties`, party);
  }
}
